<template>
  <div id="app">
    <div class="html2pdf" style="display: none">
      <vue-html2pdf
        :show-layout="false"
        :float-layout="false"
        :enable-download="false"
        :preview-modal="false"
        :paginate-elements-by-height="1300"
        filename="hee hee"
        :pdf-quality=".5"
        :manual-pagination="false"
        pdf-format="a4"
        pdf-orientation="portrait"
        pdf-content-width="210mm"
        :html-to-pdf-options="{
          enableLinks: true,
          margin: [50, 0, 50, 0]
        }"
        @beforeDownload=beforeDownload($event)
        ref="html2Pdf"
      >
          <section slot="pdf-content" class="main-pdf-content">
            <div class="pdf-inner">
              <div class="main-address">
                <div>
                  <!--  v-if="!has_different_billing_number" -->
                  <div>{{contact.firstname}} {{contact.lastname}}</div>
                  <div>{{contact.street}} {{contact.house_number}}</div>
                  <div>{{contact.post_index}} {{contact.residence}}</div>
                </div>
                <!-- <div v-else>
                  <div>{{billing_contact.firstname}} {{billing_contact.lastname}}</div>
                  <div>{{billing_contact.street}} {{billing_contact.house_number}}</div>
                  <div>{{billing_contact.post_index}} {{billing_contact.residence}}</div>
                </div> -->
                <div v-if="contact.email!=''">
                  <div>{{contact.email}}</div>
                  <div>{{contact.phone}}</div>
                </div>
              </div>
              <div class="date-of-pdf">{{document_date}}</div>
              <div class="title-of-pdf">
                <span v-if="order_type=='quote'">Angebot</span><span v-else>Bestellung</span> {{document_number+10000}} {{ sections[current_section].title }}<!--Dachrinnen Erneuerung -->
              </div>
              <!-- here comes the list of objects/roofs -->
              <div v-if="!has_repeatable">
                <div v-if="has_different_billing_number" class="ihre-address">
                  Ihre Objektadresse: {{billing_contact.firstname}} {{billing_contact.lastname}},  
                  {{billing_contact.street}} {{billing_contact.house_number}},
                  {{billing_contact.post_index}} {{billing_contact.residence}}
                </div>
                <div class="grid-pdf">
                  <table cellspacing=0 cellpadding=3>
                    <thead>
                      <th>
                        Beschreibung
                      </th>
                      <th>
                        lfdm/Stk.
                      </th>
                      <th>
                        Preis/Stk.
                      </th>
                      <th>
                        Gesamt
                      </th>
                    </thead>
                    <tbody>
                      <tr v-for="(field, i) in current_section_fields.filter(item=>item.result)" :key="'tr'+i">
                        <template v-if="(is_field_visible(field) || field.is_visible) && field.value>0"><!-- -->
                          <td>
                            <template v-if="typeof field.pdf_label!=='undefined' && field.pdf_label!==''">{{field.pdf_label}}</template>
                            <template v-else>{{field.label}}</template>
                          </td>
                          <td class="text-center-col">
                            {{find_option_value(field)}}
                          </td>
                          <td class="text-center-col">
                            {{field.sufix}} <span v-if="field.sufix">€</span>
                          </td>
                          <td class="text-center-col">
                            <span v-if="field.result">{{field.result}} €</span>
                          </td>
                        </template>
                      </tr>
                      <tr class="mindestumsatz"  v-if="mindestumsatz">
                        <td colspan="3" class="text-right-col">
                          Mindestumsatz
                        </td>
                        <td class="text-center-col">
                          {{mindestumsatz}} €
                        </td>
                      </tr>
                      <tr class="Anfahrt" v-if="sections[current_section] && sections[current_section].travel_cost_active && travel_cost!=0">
                        <td colspan="3" class="text-right-col">
                          Anfahrt
                        </td>
                        <td class="text-center-col">
                          {{travel_cost}} €
                        </td>
                      </tr>
                      <tr class="rabatt" v-if="sections[current_section] && sections[current_section].discount_active && discount!=0">
                        <td colspan="3" class="text-right-col">
                          Rabatt
                        </td>
                        <td class="text-center-col">
                          -{{discount}} €
                        </td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <!-- <tr>
                        <td colspan="3" class="text-right-col">
                          Netto
                        </td>
                        <td class="text-center-col">
                          {{netto}} €
                        </td>
                      </tr> -->
                      
                      <tr>
                        <td colspan="3" class="text-right-col">
                          Summe
                        </td>
                        <td class="text-center-col">
                          {{summe}} €
                        </td>
                      </tr>
                      
                      
                      <tr>
                        <td colspan="3" class="text-right-col">
                          MwSt. 19.00%
                        </td>
                        <td class="text-center-col">
                          {{mwst}} €
                        </td>
                      </tr>
                      <tr>
                        <td colspan="3" class="text-right-col">
                          Gesamt
                        </td>
                        <td class="text-center-col">
                          {{gesamt}} €
                        </td>
                      </tr>
                      <!-- <tr>
                        <td colspan="3" class="text-right-col">
                          Summe
                        </td>
                        <td class="text-center-col">
                          {{summe}} €
                        </td>
                      </tr>
                      <tr class="mindestumsatz"  v-if="mindestumsatz">
                        <td colspan="3" class="text-right-col">
                          Mindestumsatz
                        </td>
                        <td class="text-center-col">
                          {{mindestumsatz}} €
                        </td>
                      </tr>
                      <tr>
                        <td colspan="3" class="text-right-col">
                          Netto
                        </td>
                        <td class="text-center-col">
                          {{netto}} €
                        </td>
                      </tr>
                      <tr>
                        <td colspan="3" class="text-right-col">
                          MwSt. 19.00%
                        </td>
                        <td class="text-center-col">
                          {{mwst}} €
                        </td>
                      </tr>
                      <tr>
                        <td colspan="3" class="text-right-col">
                          Gesamt
                        </td>
                        <td class="text-center-col">
                          {{gesamt}} €
                        </td>
                      </tr> -->
                    </tfoot>
                  </table>
                </div>
                <div v-if="is_mochten" class="pdf-mochten">
                  <div v-if="mochten_mode==1">Abonnement: 2 x pro Jahr {{months[mochten_month_1 - 1].label}} - {{months[mochten_month_2 - 1].label}}</div>
                  <div v-if="mochten_mode==2">Abonnement: 1 x pro Jahr {{months[mochten_month_1 - 1].label}}</div>
                  <div v-if="mochten_mode==3">Abonnement: Alle 2 Jahre</div>
                </div>
              </div>
              <div v-else>
                <template v-for="(field, kl) in current_section_fields">
                  <template v-if="field.is_block">
                    <div  :key="'tfh'+kl" class="grid-pdf">
                      <table style="margin-top: 10px; width: 100%" cellspacing=0 cellpadding=5>
                        <thead>
                          <th>
                            Beschreibung
                          </th>
                          <th>
                            lfdm/Stk.
                          </th>
                          <th>
                            Preis/Stk.
                          </th>
                          <th>
                            Gesamt
                          </th>
                        </thead>
                      </table>
                    </div>
                    <template v-for="(group, gi) in field.groups">
                      <div :key="'h'+gi" style="display: flex; margin-top: 10px; align-items: center;">
                        <h4 style="margin-bottom: 0;margin-top:0;margin-right: 10px">Haus #{{gi+1}}</h4>
                        <div :key="'address'+gi" class="ihre-address" style="margin-top: 0">
                          Ihre Objektadresse: {{multiple_contacts[gi].firstname}} {{multiple_contacts[gi].lastname}},  
                          {{multiple_contacts[gi].street}} {{multiple_contacts[gi].house_number}},
                          {{multiple_contacts[gi].email}} {{multiple_contacts[gi].phone}}
                        </div>
                      </div>
                      <div :key="'grid'+gi" class="grid-pdf" style="margin-top:0;">
                        <table cellspacing=0 cellpadding=5>
                          <tbody>
                            <tr v-for="(field, i) in group.fields.filter(item=>item.value)" :key="'tr'+i">
                              <template v-if="(is_field_visible(field) || field.is_visible) && field.value>0"><!-- -->
                                <td>
                                  {{field.label}}
                                </td>
                                <td class="text-center-col">
                                  {{find_option_value(field)}}
                                </td>
                                <td class="text-center-col">
                                  {{field.sufix}} <span v-if="field.sufix">€</span>
                                </td>
                                <td class="text-center-col">
                                  <span v-if="field.result">{{field.result}} €</span>
                                </td>
                              </template>
                            </tr>

                            <tr class="mindestumsatz"  v-if="mindestumsatz">
                              <td colspan="3" class="text-right-col">
                                Mindestumsatz
                              </td>
                              <td class="text-center-col">
                                {{mindestumsatz}} €
                              </td>
                            </tr>
                            <tr class="Anfahrt" v-if="sections[current_section] && sections[current_section].travel_cost_active && travel_cost!=0">
                              <td colspan="3" class="text-right-col">
                                Anfahrt
                              </td>
                              <td class="text-center-col">
                                {{travel_cost}} €
                              </td>
                            </tr>
                            <tr class="rabatt" v-if="sections[current_section] && sections[current_section].discount_active && discount!=0">
                              <td colspan="3" class="text-right-col">
                                Rabatt
                              </td>
                              <td class="text-center-col">
                                -{{discount}} €
                              </td>
                            </tr>
                          </tbody>
                          
                        </table>
                      </div>
                      <!-- <div :key="'ll'+gi" class="html2pdf__page-break" /> -->
                    </template>
                    <div  :key="'tfg'+kl" class="grid-pdf">
                      <table style="margin-top: 10px; width: 100%" cellspacing=0 cellpadding=5>
                        <tfoot>
                            <!-- <tr>
                              <td colspan="3" class="text-right-col">
                                Netto
                              </td>
                              <td class="text-center-col">
                                {{netto}} €
                              </td>
                            </tr> -->
                            
                            <tr>
                              <td colspan="3" class="text-right-col">
                                Summe
                              </td>
                              <td class="text-center-col">
                                {{summe}} €
                              </td>
                            </tr>
                            
                            
                            <tr>
                              <td colspan="3" class="text-right-col">
                                MwSt. 19.00%
                              </td>
                              <td class="text-center-col">
                                {{mwst}} €
                              </td>
                            </tr>
                            <tr>
                              <td colspan="3" class="text-right-col">
                                Gesamt
                              </td>
                              <td class="text-center-col">
                                {{gesamt}} €
                              </td>
                            </tr>
                          </tfoot>
                      </table>
                    </div>
                  </template>
                </template>
              </div>
              <div v-if="current_section && sections[current_section].show_coupon">
                Gutscheincode: {{contact.gutscheincode}}    
              </div>
              <div v-if="contact.comment && contact.comment.length>0">
                Kommentar:<br>{{contact.comment}}    
              </div>
              <div class="footer-of-pdf">
                <div v-if="order_type=='quote'" v-html="footer_text_quote"></div>
                <div v-else v-html="footer_text_order"></div>
              </div>
            </div>
          </section>
      </vue-html2pdf>
    </div>
    <div class="dodel-calculator">
      <div class="sections-block" v-show="sections.length>1">
        <!-- <div class="section" v-for="(section, s_index) in sections" :class="current_section==s_index?'active':''" @click="current_section=s_index" :key="'section-'+s_index">
          <div class="image">
            <div class="overflow"></div>
            <img :src="section.image" :alt="section.title">
          </div>
          <div class="title">
            {{section.title}}
          </div>
        </div> -->

        <switch-input no="" yes="Haben Sie ein Reihenhaus? Für Reihenhäuser bieten wir einen pauschalen Festpreis an" v-model="switch_tab" />
      </div>
      <div class="section-content" v-if="current_section!=null">
        <h1>{{sections[current_section].title}}</h1>
        <div class="section-description" v-html="sections[current_section].description"></div>
        <div class="fields-block">
          <div class="fields-block-header" v-if="sections[current_section].headers.length>0">
            <div v-for="(header, h_index) in sections[current_section].headers" :key="'header-'+h_index">
              {{header.title}}
            </div>
          </div>
          <div class="fields-block-body">
            <div v-for="(field, f_index) in current_section_fields" :key="'field-'+f_index">
              <div v-if="is_field_visible(field)">
                <div v-if="field.is_block">
                  <repeatable-block v-for="(i, ind) in field.groups" :parent="sections[current_section].fields" :key="'rep'+ind" :field="i" :iteration="ind" @calculate="calculate()"/>
                </div>
                <div v-else>
                  <div v-if="field.type=='tabs' || field.type=='textarea'  || field.type=='divider'">
                    <tab-input v-if="field.type=='tabs'" v-model="field.value" :options="field.options" @calculate="calculate($event, field)" />
                    <div v-if="field.type=='textarea'">
                      <label>{{field.label}}</label>
                      <textarea-input v-model="field.value" />
                    </div>
                    <hr v-if="field.type=='divider'" />
                  </div>
                  <div v-else class="field-block-field" :style="{gridTemplateColumns: (field.result?'2fr 3fr 1fr':'2fr 4fr')}">
                    <div class="label">
                      {{field.label}}
                    </div>
                    <div class="field">
                      <div class="prefix">
                        {{field.prefix}}
                      </div>
                      <div class="input">
                        <number-input v-model="field.value" @input="process_input_event($event, field)" v-if="field.type=='number'" :min="field.min_max.min" :max="field.min_max.max" @calculate="calculate($event, field)" />
                        <switch-input v-model="field.value" v-if="field.type=='switch'" :yes="field.yes_no.yes" :no="field.yes_no.no" @calculate="calculate($event, field)" />
                        <select-input v-model="field.value" @input="process_input_event($event, field)" v-if="field.type=='select'" :options="field.options" @calculate="calculate($event, field)" />
                        <slider-input v-model="field.value" @input="process_input_event($event, field)" v-if="field.type=='slider'" :min="field.min_max.min" :max="field.min_max.max" @calculate="calculate($event, field)" />
                        <radio-group-input v-model="field.value" v-if="field.type=='radio'" :options="field.options" @calculate="calculate($event, field)" />
                        <checkbox-group-input v-model="field.value" v-if="field.type=='checkbox'" :options="field.options" @calculate="calculate($event, field)" />
                      </div>
                      <!-- <div class="suffix">
                        {{field.suffix}}
                      </div> -->
                    </div>
                    <div class="calculation" v-if="field.result">
                      = {{(field.result)}} €
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="field-block-field" v-if="sections[current_section].minimum_amount_active && mindestumsatz!=0">
              <div class="mindestumsatz label" v-if="sections[current_section].minimum_amount_active && mindestumsatz!=0">
                Mindestumsatz
              </div>
              <div class="field"></div>
              <div class="mindestumsatz calculation" v-if="sections[current_section].minimum_amount_active && mindestumsatz!=0">
                {{mindestumsatz}} €
              </div>
            </div>
            <div class="field-block-field" v-if="sections[current_section].travel_cost_active && travel_cost!=0">
              <div class="Anfahrt label" v-if="sections[current_section].travel_cost_active && travel_cost!=0">
                Anfahrt
              </div>
              <div class="field"></div>
              <div class="Anfahrt calculation" v-if="sections[current_section].travel_cost_active && travel_cost!=0">
                {{travel_cost}} €
              </div>
            </div>
            <div class="field-block-field" v-if="sections[current_section].discount_active && discount!=0">
              <div class="rabatt" v-if="sections[current_section].discount_active && discount!=0">
                Rabatt
              </div>
              <div class="field"></div>
              <div class="rabatt calculation" v-if="sections[current_section].discount_active && discount!=0">
                -{{discount}} €
              </div>
            </div>
          </div>
          <div class="fields-block-totals">
            <div class="logo">
              <img src="https://dachrinnen-reinigen.de/wp-content/uploads/2017/12/cropped-logo.jpg">
            </div>
            <div class="summe-title">
              <!-- <div class="netto">
                Netto
              </div> -->
              
              <div class="summe">
                Summe
              </div>
              <div class="mwst">
                MwSt. 19.00%
              </div>
              <div class="gesamt">
                Gesamt
              </div>
            </div>
            <div class="numbers">
              <!-- <div class="netto">
                {{netto}} €
              </div> -->
              
              <div class="summe">
                {{summe}} €
              </div>
              <div class="mwst">
                {{mwst}} €
              </div>
              <div class="gesamt">
                {{gesamt}} €
              </div>
            </div>
          </div>
          <div class="buttons-block" v-if="!show_contact_fields">
            <button class="button-secondary" @click.prevent="calculate()">
              KALKULIEREN
            </button>
            <button class="button-primary" @click.prevent="quote()">
              ANGEBOT ANFORDERN
            </button>
            <button class="button-primary" @click.prevent="order()">
              Bestellung
            </button>
          </div>
          <div class="contact-fields-block" v-if="show_contact_fields">
            <div class="mochten" v-if="sections[current_section].show_mochten">
              <div class="mochten-switch">
                <div class="text-de">
                  Möchten Sie eine automatische Dachrinnenreinigung im Abo jederzeit kündbar?
                </div>
                <div class="switch">
                  <switch-input v-model="is_mochten" yes="ja" no="nein" />
                </div>
              </div>
              <div v-if="is_mochten" class="mochten_on">
                  <tab-input v-model="mochten_mode" :options="[
                    {value: 1, label: '2 x jährlich'},
                    {value: 2, label: '1 x jährlich'},
                    {value: 3, label: 'Alle 2 Jahre'},
                  ]" />
                  <div class="months-title" v-if="mochten_mode!=3">
                    In welchem Monat / In welchen beiden Monaten ?
                  </div>
                  <div class="months">
                    <select-input v-model="mochten_month_1" :options="months" v-if="mochten_mode!=3"/>
                    <select-input v-model="mochten_month_2" :options="months" v-if="mochten_mode==1"/>
                  </div>
                </div>
            </div>
            <div class="contact-fields">
              <div>
                <h4>
                  Rechnungsanschrift
                </h4>
                <div class="fields-group">
                  <div :class="errors.firstname?'error':''">
                    <label>Nachname</label>
                    <text-input v-model="contact.firstname" />
                  </div>
                  <div :class="errors.lastname?'error':''">
                    <label>Vorname</label>
                    <text-input v-model="contact.lastname" />
                  </div>
                </div>
                <div class="fields-group">
                  <div :class="errors.street?'error':''">
                    <label>Strasse</label>
                    <text-input v-model="contact.street" />
                  </div>
                  <div :class="errors.house_number?'error':''">
                    <label>Hausnummer</label>
                    <text-input v-model="contact.house_number" />
                  </div>
                </div>
                <div class="fields-group">
                  <div :class="errors.postcode?'error':''">
                    <label>Postleitzahl</label>
                    <text-input v-model="contact.post_index" />
                  </div>
                  <div :class="errors.residence?'error':''">
                    <label>Wohnort</label>
                    <text-input v-model="contact.residence" />
                  </div>
                </div>
              </div>
              <div class="has_different_billing_address">
                <switch-input :no="false" :yes="false" v-model="has_different_billing_number" />
                <div class="text-desc">
                  Klicken Sie hier wenn Sie eine von Rechnungsadresse abweichende Objektanschrift haben
                </div>
              </div>
              <div v-if="has_different_billing_number">
                <div>
                  <div class="fields-group">
                    <div>
                      <label>Objekt Nachname</label>
                      <text-input v-model="billing_contact.firstname" />
                    </div>
                    <div>
                      <label>Objekt Vorname</label>
                      <text-input v-model="billing_contact.lastname" />
                    </div>
                  </div>
                  <div class="fields-group">
                    <div>
                      <label>Objekt Strasse</label>
                      <text-input v-model="billing_contact.street" />
                    </div>
                    <div>
                      <label>Objekt Hausnummer</label>
                      <text-input v-model="billing_contact.house_number" />
                    </div>
                  </div>
                  <div class="fields-group">
                    <div>
                      <label>Objekt Postleitzahl</label>
                      <text-input v-model="billing_contact.post_index" />
                    </div>
                    <div>
                      <label>Objekt Wohnort</label>
                      <text-input v-model="billing_contact.residence" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="fields-group">
                <div :class="errors.email?'error':''">
                  <label>E-Mail</label>
                    <text-input v-model="contact.email" />
                </div>
                <div :class="errors.phone?'error':''">
                  <label>Telefonnummer</label>
                  <text-input v-model="contact.phone" />
                </div>
              </div>
              <div v-if="multiple_contacts.length>0 && has_repeatable" class="one_of_multiple_contacts">
                <div v-for="(cont, i) in multiple_contacts" :key="'hc'+i">
                  <h4>Haus #{{i+1}}</h4>
                  <div class="fields-group">
                    <div>
                      <label>Nachname</label>
                      <text-input v-model="cont.firstname" />
                    </div>
                    <div>
                      <label>Vorname</label>
                      <text-input v-model="cont.lastname" />
                    </div>
                  </div>
                  <div class="fields-group">
                    <div>
                      <label>Hausnummer</label>
                      <text-input v-model="cont.house_number" />
                    </div>
                  </div>
                  <div class="fields-group">
                    <div>
                      <label>E-Mail</label>
                      <text-input v-model="cont.email" />
                    </div>
                    <div>
                      <label>Telefonnummer</label>
                      <text-input v-model="cont.phone" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="code_and_comment">
                <div v-if="sections[current_section].show_coupon"> <!-- should be switchable-->
                  <label>Gutscheincode</label>
                  <text-input v-model="contact.gutscheincode" />
                </div>
                <div>
                  <label>Kommentar</label>
                  <textarea-input v-model="contact.comment" />
                </div>
              </div>
              <div class="contacts_footer_block">
                <checkbox-input v-model="agb" label="Ich akzeptiere AGB" :url="agburl"/>
                <button :disabled="!agb || loading" @click.prevent="submit_order" class="button-primary" v-if="order_type=='quote'">
                  <span v-if="!loading">Bestellung</span>
                  <img v-if="loading" src="data:image/gif;base64,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" style="margin-right: 10px;">
                  <span v-if="loading">Laden...</span>
                </button>
                <button :disabled="!agb || loading" @click.prevent="submit" class="button-primary">
                  <span v-if="order_type=='order' && !loading">Bestellung</span>
                  <span v-if="order_type=='quote' && !loading">Angebot ANFORDERN</span>
                  <img v-if="loading" src="data:image/gif;base64,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" style="margin-right: 10px;">
                  <span v-if="loading">Laden...</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NumberInput from './components/number-input.vue'
import TextareaInput from './components/textarea-input.vue'
import CheckboxGroupInput from './components/checkboxgroup-input.vue'
import RadioGroupInput from './components/radiogroup-input.vue'
import SliderInput from './components/slider-input.vue'
import SwitchInput from './components/switch-input.vue'
import SelectInput from './components/select-input.vue'
import TabInput from './components/tab-input.vue'
import RepeatableBlock from './components/reapeatable-block.vue'
import TextInput from './components/text-input.vue'
import CheckboxInput from './components/checkbox-input.vue'
import VueHtml2pdf from 'vue-html2pdf'
import axios from 'axios'

export default {
  name: 'App',
  components: {
    NumberInput,
    SliderInput,
    TextareaInput,
    SwitchInput,
    SelectInput,
    TabInput,
    RadioGroupInput,
    CheckboxGroupInput,
    RepeatableBlock,
    TextInput,
    CheckboxInput,
    VueHtml2pdf,
  },
  computed: {
    current_section_fields(){
      if(this.sections[this.current_section])
        return this.sections[this.current_section].fields
      return []
    },
    summe(){
      return (parseFloat(this.netto) + parseFloat(this.mindestumsatz) + parseFloat(this.travel_cost) + parseFloat(this.discount) * -1).toFixed(2)
    },
    // pre_summe(){
    //   return (parseFloat(this.netto) + parseFloat(this.mindestumsatz) + parseFloat(this.travel_cost)).toFixed(2)
    // },
    mindestumsatz(){
      if(this.sections[this.current_section]){
        if(this.sections[this.current_section].minimum_amount_active){
          if(parseFloat(this.netto) + parseFloat(this.travel_cost) < parseFloat(this.sections[this.current_section].minimum_amount)){
            return (parseFloat(this.sections[this.current_section].minimum_amount) - parseFloat(this.netto) - parseFloat(this.travel_cost)).toFixed(2)
          }
        }
      }
      return 0
    },
    discount(){
      if(this.sections[this.current_section]){
        if(this.sections[this.current_section].discount_active){
          let result = 0
          this.sections[this.current_section].discounts.forEach(discount => {
            if(parseFloat(this.netto)>parseFloat(discount.minimum_amount))
              result = parseFloat(this.netto) * parseFloat(discount.percent) / 100
          })
          return result.toFixed(2)
        }
      }
      return 0
    },
    travel_cost(){
      if(this.sections[this.current_section]){
        if(this.sections[this.current_section].travel_cost_active){
          // console.log(this.summe, this.sections[this.current_section].travel_cost_minimum, parseFloat(this.summe) < parseFloat(this.sections[this.current_section].travel_cost_minimum))
          if(parseFloat(this.sections[this.current_section].travel_cost_minimum)>parseFloat(this.netto)){
            return (parseFloat(this.sections[this.current_section].travel_cost_amount)).toFixed(2)
          }
        }
      }
      return 0
    },
    netto(){
      let summ = 0
      this.current_section_fields.forEach(field=>{
        if(!field.is_block){
          if(this.is_field_visible(field))
            summ+=parseFloat(field.result)
        }else{
          field.groups.forEach(group_item=>{
            group_item.fields.forEach(fld=>{
              // console.log('is fld visible', fld)
              if(fld.is_visible)
                summ+=parseFloat(fld.result)
            })
          })
        }
      })
      return summ.toFixed(2)
    },
    mwst(){
      return (parseFloat(this.summe)*0.19).toFixed(2)
    },
    gesamt(){
      //totals
      return (
        parseFloat(this.summe) + parseFloat(this.mwst)
        // parseFloat(this.summe) + 
        // parseFloat(this.travel_cost) + 
        // parseFloat(this.mindestumsatz) + 
        // parseFloat(this.discount) * -1
      ).toFixed(2)
    },
    has_repeatable(){
      let result = false
      if(this.sections[this.current_section]){
        this.sections[this.current_section].fields.forEach(i=>{
          if(i.is_block)
            result = true
        })
      }
      return result
    }
  },
  methods: {
    triggerEvent(name, formName = 'Rechnerformular'){
      //GTM
      // eslint-disable-next-line
      if (window.dataLayer || ga) {
        // console.log('GTM', name, formName)
        // eslint-disable-next-line
        // gtag('event', name, {
        //   event_category: formName,
        //   event_label: formName,
        //   send_to: 'G-5RSXX1YV2C',
        // });
        // eslint-disable-next-line
        ga('send', 'event', formName, name);
        // eslint-disable-next-line
        dataLayer.push({
          event: name,
          // formName: formName,
          // plan: this.i_want,
          // material: this.material,
          // color: this.color,
          // roof: this.roof,
          // submittedAt: new Date().toISOString()
        });
      }
      //FB
      // eslint-disable-next-line
      if (typeof fbq === 'function') {
        // eslint-disable-next-line
        fbq('trackCustom', name, {
          formName,
          submittedAt: new Date().toISOString()
        });
      }
    },
    triggerEventBing(name){
      //Bing
      if (typeof window.uetq === 'object') {
        window.uetq.push('event', name);
      }else{
        console.warn('Bing event', name, 'not triggered, because uetq is not defined');
      }
    },
    find_option_value(field){
      let result = ''
      switch(field.type){
        case "select":
        case "tabs": 
        case "checkbox":
        case "radio":
          field.options.forEach(option=>{
            if(option.value==field.value)
              result = option.label
          })
          break;
        case "switch":
          // console.log(field.value, typeof field.value, field)
          if(field.value===true)
            result = field.yes_no.yes
          else
            result = field.yes_no.no
          break;
        default:   
          result = field.value
      }
      return result;
    },
    submit_order(){
      if(this.contact.email==''){
        this.errors.email = true
      }else{
        // eslint-disable-next-line no-useless-escape
        const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if(!regex.test(this.contact.email)){
          this.errors.email = true
        }else{
          this.errors.email = false
        }
      }

      if(this.contact.phone=='')
        this.errors.phone = true
      else
        this.errors.phone = false

      if(this.contact.firstname=='')
        this.errors.firstname = true
      else
        this.errors.firstname = false

      if(this.contact.lastname=='')
        this.errors.lastname = true
      else
        this.errors.lastname = false

      if(this.errors.email + this.errors.phone + this.errors.firstname + this.errors.lastname > 0)
        return false;

      this.loading = true
      axios.post('/wp-admin/admin-ajax.php?action=ddlc-submit_order', {
        section: this.sections[this.current_section],
        is_mochten: this.is_mochten,
        agb: this.agb,
        mochten_mode: this.mochten_mode,
        mochten_month_1: this.mochten_month_1,
        mochten_month_2: this.mochten_month_2,
        contact: this.contact,
        has_different_billing_address: this.has_different_billing_number,
        billing_contact: this.billing_contact,
        multiple_contacts: this.multiple_contacts,
        summe: this.summe,
        mindestumsatz: this.mindestumsatz,
        netto: this.netto,
        mwst: this.mwst,
        gesamt: this.gesamt,
        travel_cost: this.travel_cost,
        discount: this.discount,
        has_repeatable: this.has_repeatable,
      }).then(response=>{
        this.document_date = response.data.date
        this.document_number = response.data.id
        this.$refs.html2Pdf.generatePdf()
      })
    },
    submit(){
      if(this.contact.email==''){
        this.errors.email = true
      }else{
        // eslint-disable-next-line no-useless-escape
        const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if(!regex.test(this.contact.email)){
          this.errors.email = true
        }else{
          this.errors.email = false
        }
      }

      if(this.contact.phone=='')
        this.errors.phone = true
      else
        this.errors.phone = false

      if(this.contact.firstname=='')
        this.errors.firstname = true
      else
        this.errors.firstname = false

      if(this.contact.lastname=='')
        this.errors.lastname = true
      else
        this.errors.lastname = false

      if(this.errors.email + this.errors.phone + this.errors.firstname + this.errors.lastname > 0)
        return false;

      this.loading = true
      axios.post('/wp-admin/admin-ajax.php?action=ddlc-submit_'+this.order_type, {
        section: this.sections[this.current_section],
        is_mochten: this.is_mochten,
        agb: this.agb,
        mochten_mode: this.mochten_mode,
        mochten_month_1: this.mochten_month_1,
        mochten_month_2: this.mochten_month_2,
        contact: this.contact,
        has_different_billing_address: this.has_different_billing_number,
        billing_contact: this.billing_contact,
        multiple_contacts: this.multiple_contacts,
        summe: this.summe,
        mindestumsatz: this.mindestumsatz,
        netto: this.netto,
        mwst: this.mwst,
        gesamt: this.gesamt,
        travel_cost: this.travel_cost,
        discount: this.discount,
        has_repeatable: this.has_repeatable,
      }).then(response=>{
        this.document_date = response.data.date
        this.document_number = response.data.id
        this.$refs.html2Pdf.generatePdf()
      })
    },
    quote(){
      this.order_type = 'quote'
      this.show_contact_fields = true
    },
    order(){
      this.order_type = 'order'
      this.show_contact_fields = true
    },
    process_input_event(event, field){
      let depended_on = this.is_field_depended_on(field)
      if(depended_on!==false){
        let clone = JSON.parse(JSON.stringify(depended_on))//Object.assign({}, depended_on)
        // delete clone.groups;
        if(depended_on.groups.length>event){
          depended_on.groups.splice(event, depended_on.groups.length)
          this.multiple_contacts.splice(event, depended_on.groups.length)
        }else{
          for(let i = depended_on.groups.length; i<event;i++){
            depended_on.groups.push(JSON.parse(JSON.stringify(clone)))
            this.multiple_contacts.push({
              firstname: '',
              lastname: '',
              house_number: '',
              email: '',
              phone: '',
            })
          }
        }
      }
    },
    is_field_depended_on(field){
      let result = false
      this.sections[this.current_section].fields.forEach(item=>{
        if(item.is_block){
          if(item.depends_on == field.id){
            result = item
          }
        }
      })
      return result
    },
    range(depends){
      let number_of_repeats = this.get_field_value(depends)
      let result = []
      for(let i=0;i<number_of_repeats;i++)
        result.push(i)
      return result
    },
    section(){
      if(this.current_section!=null)
        return this.sections[this.current_section]
      return {}
    },
    get_valid_calculation(field){
      let default_calculation = false
      let undefault_calculation = false
      field.calculations.forEach(calculation=>{
        // console.log(calculation)
        if(calculation.condition.type=='field'){
          if(calculation.condition.value == this.get_field_value(calculation.condition.field))
            undefault_calculation = calculation
        }
        if(calculation.condition.type=='default')
          default_calculation = calculation
      })
      if(undefault_calculation!==false)
        return undefault_calculation
      else
        return default_calculation
    },
    get_field_value(search_id){
      let value = 0
      this.sections[this.current_section].fields.forEach(field => {
        if(field.id==search_id)
          value = field.value
      })
      return value
    },
    generate_equation(calculation, data){
      let string = ''
      if(calculation!==false)
        calculation.items.forEach(item=>{
          if(item.input=='this')
            string+=data+item.operator
          else if(item.input=='number')
            string+=item.number+item.operator
          else
            string+=this.get_field_value(item.input)+item.operator
        })
      return string.replace('=', '')
    },
    calculate(){
      this.sections[this.current_section].fields.forEach((field, index)=>{
        if(field.type=='text')
          field.value = 1
        let equation = this.generate_equation(this.get_valid_calculation(field), field.value)
        // console.log(equation, field)
        let result = false
        if(equation!=='')
          result = eval(equation)
        if(typeof result ==='number')
          field.result = result.toFixed(2)
        this.$set(this.sections[this.current_section].fields, index, field)
        
      })
      
    },
    is_field_visible(field){
      let result = true
      if(field.conditions.length>0){
        let conclusions_string = '';
        field.conditions.forEach((condition, index)=>{
          let conclusion = ''
          let operator = ''
          if(this.get_field_value(condition.field)==condition.value)
            conclusion='true';
          else
            conclusion='false';
          
          if(index!==field.conditions.length-1)
            if(condition.operand=='and')
              operator=' && '
            else
              operator=' || '
          
          conclusions_string+=conclusion+operator
        })
        result = eval(conclusions_string);
      }
      return result
    },
    async beforeDownload ({ html2pdf, pdfContent }) {
        // console.log(pdfContent)
        // let email = pdfContent
        await html2pdf().set({
          // margin: 0,
      
          image: {
              type: 'jpeg', 
              quality: .95
          },
      
          enableLinks: false,
          margin: [50, 0, 45, 0],
      
          html2canvas: {
              scale: 2,
              useCORS: true
          },
      
          jsPDF: {
              unit: 'mm',
              format: 'a4',
              orientation: 'portrait'
          },
          pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
        }).from(pdfContent).toPdf().get('pdf').then((pdf) => {
                var totalPages = pdf.internal.getNumberOfPages(); 
                // pdf.deletePage(totalPages)
                for (var i = 1; i <= totalPages; i++) {
                    pdf.setPage(i);
                    
                    if(i==1)
                      pdf.addImage(this.heading, 'PNG', 0, 50, 210, 47.31, undefined, 'FAST')
                    pdf.addImage(this.header, 'PNG', 0, 0, 210, 32.58, undefined, 'FAST')
                    pdf.addImage(this.footer, 'PNG', 0, pdf.internal.pageSize.getHeight()-30.38, 210, 30.38, undefined, 'FAST')

                } 
            }).output('datauristring').then((pdf)=>{
              axios.post('/wp-admin/admin-ajax.php?action=ddlc-update_entity', {
                id: this.document_number,
                file: pdf
              }).then(()=>{
                //this.next_pdf()
                this.triggerEvent("form_submitted");
                this.triggerEventBing("Form successfully submitted");
                setTimeout(()=>{
                  window.location = this.thankyoupage
                }, 1000)
                
                //go to thank you page
              })
            })
    },
  },
  // watch: {
  //   current_section(){
  //     this.multiple_contacts = []
  //   }
  // },
  watch: {
    switch_tab(val){
      if(val===false)
        this.current_section = 0
      else
        this.current_section = 1
    }
  },
  data(){
    return {

      switch_tab: false,

      //this data is received with AJAX once the submit is clicked
      document_date: '',
      document_number: '',
      footer_text_quote: '',
      footer_text_order: '',

      header: '',
      footer: '',
      heading: '',
      agburl: '',
      thankyoupage: '',
      loading: false,

      errors: {
        firstname: false,
        lastname: false,
        street: false,
        house_number: false,
        postcode: false,
        residence: false,
        email: false,
        phone: false,
      },

      current_section: 0,
      show_contact_fields: false,
      order_type: '',
      is_mochten: false,
      agb: false,
      mochten_mode: 1,
      mochten_month_1: 1,
      mochten_month_2: 9,
      contact: {
        firstname: '',
        lastname: '',
        street: '',
        house_number: '',
        post_index: '',
        residence: '',
        email: '',
        phone: '',
        gutscheincode: '',
        comment: '',
      },
      has_different_billing_number: false,
      billing_contact: {
        firstname: '',
        lastname: '',
        street: '',
        house_number: '',
        post_index: '',
        residence: '',
      },
      multiple_contacts:[],

      months: [
        {value: 1, label: 'Januar',},
        {value: 2, label: 'Februar',},
        {value: 3, label: 'März',},
        {value: 4, label: 'April',},
        {value: 5, label: 'Mai',},
        {value: 6, label: 'Juni',},
        {value: 7, label: 'Juli',},
        {value: 8, label: 'August',},
        {value: 9, label: 'September',},
        {value: 10, label: 'Oktober',},
        {value: 11, label: 'November',},
        {value: 12, label: 'Dezember',},
      ],
      // sections: [{"title":"Section title","id":"3880fa1fccc42", "description":"Sollten Sie Großkunde sein, so bieten wir unsere Dienstleistungen zu Sonderkonditionen. Als Großkunde können Sie sich bezeichnen, wenn es sich um eine Schule, eine Behörde, eine Hausverwaltung, industrielle Firma oder Kaserne handelt. Dachrinnenreinigungen bieten wir im gesamten nördlichen Deutschland an. Handelt es sich um ein großes Projekt, so können Sie auch eine Anfrage auf bundesweite Arbeit stellen. Natürlich erhalten Sie Dachrinnenreinigungen als Großkunde zu einem fairen Preis, welcher sich als Mengenrabatt verstehen kann. So kommen Sie günstig davon, ohne dass wir bei der Arbeit Kompromisse eingehen. Überzeugen Sie sich selbst und werden Sie glücklicher Großkunde!", "headers":[{"title":"Höhe der Dachrinne"},{"title":"Länge ihrer Dachrinne"},{"title":"Gesamtpreis"}],"image":"https://storage.concert.ua/JmJ/8/SZ/61892ae97a9be/aa16.jpg","fields":[{"label":"Field 1","id":"cce23737","type":"number","options":[],"calculations":[{"items":[{"input":"this","operator":"*","number":""},{"input":"number","operator":"=","number":"3"}],"condition":{"type":"default","field":"","value":""}}],"conditions":[]},{"label":"Field 2","id":"b78bb3fce","type":"slider","options":[],"calculations":[{"items":[{"input":"this","operator":"*","number":""},{"input":"number","operator":"+","number":"2"},{"input":"cce23737","operator":"*","number":""},{"input":"cce23737","operator":"=","number":""}],"condition":{"type":"default","field":"","value":""}}],"conditions":[]},{"label":"Switch","id":"c434fd83f","type":"switch","options":[],"calculations":[],"conditions":[]},{"label":"Select","id":"e9c58de81","type":"select","options":[{"value":"1","label":"first option"},{"value":"2","label":"second option"}],"calculations":[{"items":[{"input":"cce23737","operator":"*","number":""},{"input":"this","operator":"=","number":""}],"condition":{"type":"default","field":"","value":""}}],"conditions":[{"field":"c434fd83f","value":"1","operand":"and"}]}]}],
      // sections: [{"title":"Test title","id":"d1d10c91c15f1","image":"https://storage.concert.ua/JmJ/8/SZ/61892ae97a9be/aa16.jpg","show_mochten": true, "fields":[{"is_block":false,"label":"Test","id":"a54eac0ed","type":"number","options":[],"yes_no":{},"min_max":{"min":"0","max":"100"},"calculations":[{"items":[{"input":"this","operator":"*","number":""},{"input":"number","operator":"=","number":"1.1"}],"condition":{"type":"default","field":"","value":""}}],"conditions":[],"prefix":"1.1€ * ","sufix":""},{"is_block":false,"label":"Slider","id":"9af2978b9","type":"slider","options":[],"yes_no":{},"min_max":{"min":"0","max":"100"},"calculations":[{"items":[{"input":"this","operator":"*","number":""},{"input":"number","operator":"+","number":"2.2"},{"input":"a54eac0ed","operator":"*","number":""},{"input":"number","operator":"=","number":"1.1"}],"condition":{"type":"default","field":"","value":""}}],"conditions":[],"prefix":"Test + 2.2€ *","sufix":"+ TEST"},{"is_block":false,"label":"Switch","id":"82a73bf8a","type":"switch","options":[],"yes_no":{"yes":"yes","no":"no"},"min_max":{},"calculations":[],"conditions":[],"prefix":"","sufix":""},{"is_block":false,"label":"","id":"0fa334179","type":"divider","options":[],"yes_no":{},"min_max":{},"calculations":[],"conditions":[]},{"is_block":false,"label":"Select","id":"9e10dc927","type":"select","options":[{"value":"1","label":"one"},{"value":"2","label":"two"}],"yes_no":{},"min_max":{},"calculations":[{"items":[{"input":"a54eac0ed","operator":"*","number":""},{"input":"number","operator":"+","number":"1.1"},{"input":"this","operator":"*","number":""},{"input":"number","operator":"=","number":"4"}],"condition":{"type":"default","field":"","value":""}}],"conditions":[{"field":"82a73bf8a","value":"1","operand":"and"}],"prefix":"4 * "}],"headers":[{"title":"Title"},{"title":"Pre"},{"title":"Price"}],"description":"Sollten Sie Großkunde sein, so bieten wir unsere Dienstleistungen zu Sonderkonditionen. Als Großkunde können Sie sich bezeichnen, wenn es sich um eine Schule, eine Behörde, eine Hausverwaltung, industrielle Firma oder Kaserne handelt. Dachrinnenreinigungen bieten wir im gesamten nördlichen Deutschland an. Handelt es sich um ein großes Projekt, so können Sie auch eine Anfrage auf bundesweite Arbeit stellen. Natürlich erhalten Sie Dachrinnenreinigungen als Großkunde zu einem fairen Preis, welcher sich als Mengenrabatt verstehen kann. So kommen Sie günstig davon, ohne dass wir bei der Arbeit Kompromisse eingehen. Überzeugen Sie sich selbst und werden Sie glücklicher Großkunde!"},{"title":"Business Section","id":"2f5b367ac047d","image":"https://dachrinnen-reinigen.de/wp-content/uploads/2020/01/IMG_1149-scaled.jpeg","show_mochten": false, "fields":[{"is_block":false,"label":"Number of houses","id":"46da250fe","type":"number","options":[],"yes_no":{},"min_max":{"min":"1","max":"100"},"calculations":[],"conditions":[]},{"is_block":true,"label":"Haus #","id":"c74326d7e","type":"block","options":[],"calculations":[],"conditions":[],"fields":[{"is_block":false,"label":"Roof","id":"62a9fc0f5","type":"number","options":[],"yes_no":{},"min_max":{"min":"0","max":"1000"},"calculations":[{"items":[{"input":"this","operator":"*","number":""},{"input":"number","operator":"=","number":"5"}],"condition":{"type":"default","field":"","value":""}}],"conditions":[],"prefix":"5 * "}],"depends_on":"46da250fe"}],"headers":[],"description":"Has multiple fields in block"}]
      //sections: [{"title":"test","id":"bbccecd2bbfb4","image":"","fields":[{"is_block":false,"label":"test","id":"779111491","type":"number","options":[],"yes_no":{},"min_max":{"min":"0","max":"10000"},"calculations":[{"items":[{"input":"this","operator":"*","number":""},{"input":"number","operator":"=","number":"6"}],"condition":{"type":"default","field":"","value":""}},{"items":[{"input":"this","operator":"*","number":""},{"input":"number","operator":"=","number":"2"}],"condition":{"type":"field","field":"070f5fff5","value":"1"}},{"items":[{"input":"this","operator":"*","number":""},{"input":"number","operator":"=","number":"3"}],"condition":{"type":"field","field":"070f5fff5","value":"0"}}],"conditions":[],"prefix":"test","sufix":"test"},{"is_block":false,"label":"switch","id":"070f5fff5","type":"switch","options":[],"yes_no":{"yes":"ja","no":"nies"},"min_max":{},"calculations":[],"conditions":[],"prefix":"test","sufix":"test"}],"headers":[],"show_mochten":false}]
      sections: [],
      // sections: [{"title":"DACHRINNENREINIGUNG PRIVATKUNDEN","id":"7166bb4625d1b","image":"https://dachrinnen-reinigen.de/wp-content/plugins/dodel-dachrinnen-reinigen-rechner/uploads/1639007138.png","fields":[{"is_block":false,"label":"bis 4m","id":"017688575","type":"number","options":[],"yes_no":{},"min_max":{"min":"0","max":"1000"},"calculations":[{"items":[{"input":"this","operator":"*","number":""},{"input":"number","operator":"=","number":"2.30"}],"condition":{"type":"default","field":"","value":""}}],"conditions":[],"prefix":"2,30 €/lfdm x","sufix":"2,30","value":0,"result":"0.00"},{"is_block":false,"label":"4m - 6,5m","id":"887afea54","type":"number","options":[],"yes_no":{},"min_max":{"min":"0","max":"1000"},"calculations":[{"items":[{"input":"this","operator":"*","number":""},{"input":"number","operator":"=","number":"2.9"}],"condition":{"type":"default","field":"","value":""}}],"conditions":[],"prefix":"2,90 €/lfdm x","sufix":"2,90","value":0,"result":"0.00"},{"is_block":false,"label":"6,5m - 9m","id":"4399aa5fb","type":"number","options":[],"yes_no":{},"min_max":{"min":"0","max":"1000"},"calculations":[{"items":[{"input":"this","operator":"*","number":""},{"input":"number","operator":"=","number":"4.2"}],"condition":{"type":"default","field":"","value":""}}],"conditions":[],"prefix":"4,20 €/lfdm x","sufix":"4,20","value":0,"result":"0.00"},{"is_block":false,"label":"ab 9m","id":"39f700a59","type":"text","options":[],"yes_no":{},"min_max":{},"calculations":[],"conditions":[],"prefix":"Preis auf Anfrage","value":1,"result":0},{"is_block":false,"label":"Laubstop reinigen/demontieren","id":"3c09489d5","type":"number","options":[],"yes_no":{},"min_max":{"min":"0","max":"1000"},"calculations":[{"items":[{"input":"this","operator":"*","number":""},{"input":"number","operator":"=","number":"2.3"}],"condition":{"type":"default","field":"","value":""}}],"conditions":[],"prefix":"2,30 €/lfdm","sufix":"2,30","value":0,"result":"0.00"},{"is_block":false,"label":"Zusatzleistungen","id":"528db045e","type":"switch","options":[],"yes_no":{"yes":"ja","no":"nein"},"min_max":{},"calculations":[],"conditions":[],"value":0,"result":0},{"is_block":false,"label":"Dachrinnen Innenanstrich Dickschicht Lasur","id":"4481716ef","type":"number","options":[],"yes_no":{},"min_max":{"min":"0","max":"1000"},"calculations":[{"items":[{"input":"this","operator":"*","number":""},{"input":"number","operator":"=","number":"7.14"}],"condition":{"type":"default","field":"","value":""}}],"conditions":[{"field":"528db045e","value":"1","operand":"and"}],"prefix":"7,14 €/lfdm","sufix":"7,14","value":0,"result":"0.00"},{"is_block":false,"label":"Reparatur Dehnungsstück bis 6,5m","id":"d2ce190fe","type":"select","options":[{"value":"1","label":"1 Stück"},{"value":"2","label":"2 Stück"},{"value":"3","label":"3 Stück"},{"value":"4","label":"4 Stück"},{"value":"5","label":"5 Stück"},{"value":"6","label":"6 Stück"},{"value":"7","label":"7 Stück"},{"value":"8","label":"8 Stück"},{"value":"9","label":"9 Stück"},{"value":"10","label":"10 Stück"},{"value":"11","label":"11 Stück"},{"value":"12","label":"12 Stück"},{"value":"13","label":"13 Stück"},{"value":"14","label":"14 Stück"},{"value":"15","label":"15 Stück"},{"value":"16","label":"16 Stück"},{"value":"17","label":"17 Stück"},{"value":"18","label":"18 Stück"},{"value":"19","label":"19 Stück"},{"value":"20","label":"20 Stück"}],"yes_no":{},"min_max":{},"calculations":[{"items":[{"input":"this","operator":"*","number":""},{"input":"number","operator":"=","number":"58.82"}],"condition":{"type":"default","field":"","value":""}}],"conditions":[{"field":"528db045e","value":"1","operand":"and"}],"prefix":"58,82 €/Stk.","sufix":"58,82","value":0,"result":"0.00"},{"is_block":false,"label":"Fallrohrsieb Zink (Lieferung und Einbau)","id":"00a1a4918","type":"select","options":[{"value":"1","label":"1 Stück"},{"value":"2","label":"2 Stück"},{"value":"3","label":"3 Stück"},{"value":"4","label":"4 Stück"},{"value":"5","label":"5 Stück"},{"value":"6","label":"6 Stück"},{"value":"7","label":"7 Stück"},{"value":"8","label":"8 Stück"},{"value":"9","label":"9 Stück"},{"value":"10","label":"10 Stück"},{"value":"11","label":"11 Stück"},{"value":"12","label":"12 Stück"},{"value":"13","label":"13 Stück"},{"value":"14","label":"14 Stück"},{"value":"15","label":"15 Stück"},{"value":"16","label":"16 Stück"},{"value":"17","label":"17 Stück"},{"value":"18","label":"18 Stück"},{"value":"19","label":"19 Stück"},{"value":"20","label":"20 Stück"}],"yes_no":{},"min_max":{},"calculations":[{"items":[{"input":"this","operator":"*","number":""},{"input":"number","operator":"=","number":"10.08"}],"condition":{"type":"default","field":"","value":""}}],"conditions":[{"field":"528db045e","value":"1","operand":"and"}],"prefix":"10,08 €/Stk.","sufix":"10,08","value":0,"result":"0.00"},{"is_block":false,"label":"Fallrohrsieb Kupfer (Lieferung und Einbau)","id":"641c5c87","type":"select","options":[{"value":"1","label":"1 Stück"},{"value":"2","label":"2 Stück"},{"value":"3","label":"3 Stück"},{"value":"4","label":"4 Stück"},{"value":"5","label":"5 Stück"},{"value":"6","label":"6 Stück"},{"value":"7","label":"7 Stück"},{"value":"8","label":"8 Stück"},{"value":"9","label":"9 Stück"},{"value":"10","label":"10 Stück"},{"value":"11","label":"11 Stück"},{"value":"12","label":"12 Stück"},{"value":"13","label":"13 Stück"},{"value":"14","label":"14 Stück"},{"value":"15","label":"15 Stück"},{"value":"16","label":"16 Stück"},{"value":"17","label":"17 Stück"},{"value":"18","label":"18 Stück"},{"value":"19","label":"19 Stück"},{"value":"20","label":"20 Stück"}],"yes_no":{},"min_max":{},"calculations":[{"items":[{"input":"this","operator":"*","number":""},{"input":"number","operator":"=","number":"11.76"}],"condition":{"type":"default","field":"","value":""}}],"conditions":[{"field":"528db045e","value":"1","operand":"and"}],"prefix":"11,76 €/Stk.","sufix":"11,76","value":0,"result":"0.00"}],"headers":[{"title":"Höhe der Dachrinne"},{"title":"Länge ihrer Dachrinne"},{"title":"Gesamtpreis"}],"show_mochten":true,"description":"Auf dieser Seite finden Sie eine Preisübersicht für jegliche Dachrinnenreinigungen von Einfamilien- oder Mehrparteienhäusern. Für eine Preisauskunft, finden Sie unten unseren Kalkulator. Geben Sie ganz einfach Ihre Daten ein und erhalten Sie ein Angebot.nnZögern Sie nicht, uns bei Fragen zu kontaktieren. Wir stehen Ihnen mit unserer 15-jährigen Erfahrung gerne zur Seite und freuen uns auf Sie und Ihren Auftrag!","show_coupon":true},{"title":"DACHRINNENREINIGUNG REIHENHÄUSER","id":"201f2c5d85076","image":"https://dachrinnen-reinigen.de/wp-content/plugins/dodel-dachrinnen-reinigen-rechner/uploads/1639007155.png","fields":[{"is_block":false,"label":"Anzahl der Häuser","id":"d4bd891ff","type":"select","options":[{"value":"1","label":"1"},{"value":"2","label":"2"},{"value":"3","label":"3"},{"value":"4","label":"4"},{"value":"5","label":"5"},{"value":"6","label":"6"},{"value":"7","label":"7"},{"value":"8","label":"8"},{"value":"9","label":"9"},{"value":"10","label":"10"},{"value":"11","label":"11"},{"value":"12","label":"12"},{"value":"13","label":"13"},{"value":"14","label":"14"},{"value":"15","label":"15"},{"value":"16","label":"16"},{"value":"17","label":"17"},{"value":"18","label":"18"},{"value":"19","label":"19"},{"value":"20","label":"20"}],"yes_no":{},"min_max":{},"calculations":[],"conditions":[],"sufix":"","value":0,"result":0},{"is_block":true,"label":"Haus #","id":"d7b4a5f0f","type":"block","options":[],"calculations":[],"conditions":[],"fields":[{"is_block":false,"label":"1-4 Häuser (1/2 Haus Rückseite)","id":"d7171500b","type":"text","options":[],"yes_no":{},"min_max":{},"calculations":[{"items":[{"input":"number","operator":"=","number":"54.62"}],"condition":{"type":"default","field":"d4bd891ff","value":"4"}}],"conditions":[{"field":"d4bd891ff","value":"1","operand":"or"},{"field":"d4bd891ff","value":"2","operand":"or"},{"field":"d4bd891ff","value":"3","operand":"or"},{"field":"d4bd891ff","value":"4","operand":"and"}],"sufix":"54,62"},{"is_block":false,"label":"5-9 Häuser","id":"a52986a68","type":"text","options":[],"yes_no":{},"min_max":{},"calculations":[{"items":[{"input":"number","operator":"=","number":"25"}],"condition":{"type":"default","field":"d4bd891ff","value":"9"}}],"conditions":[{"field":"d4bd891ff","value":"5","operand":"or"},{"field":"d4bd891ff","value":"6","operand":"or"},{"field":"d4bd891ff","value":"7","operand":"or"},{"field":"d4bd891ff","value":"8","operand":"or"},{"field":"d4bd891ff","value":"9","operand":"and"}],"sufix":"25,00"},{"is_block":false,"label":"ab 10 Häuser","id":"5a7a7b8f5","type":"text","options":[],"yes_no":{},"min_max":{},"calculations":[{"items":[{"input":"number","operator":"=","number":"0.01"}],"condition":{"type":"default","field":"d4bd891ff","value":"20"}}],"conditions":[{"field":"d4bd891ff","value":"10","operand":"or"},{"field":"d4bd891ff","value":"11","operand":"or"},{"field":"d4bd891ff","value":"12","operand":"or"},{"field":"d4bd891ff","value":"13","operand":"or"},{"field":"d4bd891ff","value":"14","operand":"or"},{"field":"d4bd891ff","value":"15","operand":"or"},{"field":"d4bd891ff","value":"16","operand":"or"},{"field":"d4bd891ff","value":"17","operand":"or"},{"field":"d4bd891ff","value":"18","operand":"or"},{"field":"d4bd891ff","value":"19","operand":"or"},{"field":"d4bd891ff","value":"20","operand":"and"}],"sufix":"0,01"},{"is_block":false,"label":"","id":"c87fb83fa","type":"radio","options":[{"value":"1","label":"beide Seiten"},{"value":"2","label":"nur Vorderseite "},{"value":"3","label":"nur Rückseite"}],"yes_no":{},"min_max":{},"calculations":[],"conditions":[]},{"is_block":false,"label":"Zusatzleistungen","id":"3255f49ba","type":"switch","options":[],"yes_no":{"yes":"ja","no":"nein"},"min_max":{},"calculations":[],"conditions":[]},{"is_block":false,"label":"bis 4m","id":"ebffd69ae","type":"number","options":[],"yes_no":{},"min_max":{"min":"0","max":"1000"},"calculations":[{"items":[{"input":"this","operator":"*","number":""},{"input":"number","operator":"=","number":"2.3"}],"condition":{"type":"default","field":"","value":""}}],"conditions":[{"field":"3255f49ba","value":"1","operand":"and"}],"prefix":"2,30 €/lfdm x","sufix":"2,30"},{"is_block":false,"label":"4m - 7m","id":"cc2c2e5d1","type":"number","options":[],"yes_no":{},"min_max":{"min":"0","max":"1000"},"calculations":[{"items":[{"input":"this","operator":"*","number":""},{"input":"number","operator":"=","number":"2.90"}],"condition":{"type":"default","field":"","value":""}}],"conditions":[{"field":"3255f49ba","value":"1","operand":"and"}],"prefix":"2,90 €/lfdm x","sufix":"2,90"},{"is_block":false,"label":"7m - 9m","id":"7a4fa9c1e","type":"number","options":[],"yes_no":{},"min_max":{"min":"0","max":"1000"},"calculations":[{"items":[{"input":"this","operator":"*","number":""},{"input":"number","operator":"=","number":"4.20"}],"condition":{"type":"default","field":"","value":""}}],"conditions":[{"field":"3255f49ba","value":"1","operand":"and"}],"prefix":"4,20 €/lfdm x","sufix":"4,20"},{"is_block":false,"label":"Laubstop reinigen/demontieren","id":"a4cda7405","type":"number","options":[],"yes_no":{},"min_max":{"min":"0","max":"1000"},"calculations":[{"items":[{"input":"this","operator":"*","number":""},{"input":"number","operator":"=","number":"2.30"}],"condition":{"type":"default","field":"","value":""}}],"conditions":[{"field":"3255f49ba","value":"1","operand":"and"}],"prefix":"2,30 €/lfdm","sufix":"2,30"},{"is_block":false,"label":"Dachrinnen Innenanstrich Dickschicht Lasur","id":"b2635eff4","type":"number","options":[],"yes_no":{},"min_max":{"min":"0","max":"1000"},"calculations":[{"items":[{"input":"this","operator":"*","number":""},{"input":"number","operator":"=","number":"7.14"}],"condition":{"type":"default","field":"","value":""}}],"conditions":[{"field":"3255f49ba","value":"1","operand":"and"}],"prefix":"7,14 €/lfdm","sufix":"7,14"},{"is_block":false,"label":"Reparatur Dehnungsstück","id":"dd52b3107","type":"number","options":[],"yes_no":{},"min_max":{"min":"0","max":"20"},"calculations":[{"items":[{"input":"this","operator":"*","number":""},{"input":"number","operator":"=","number":"58.82"}],"condition":{"type":"default","field":"","value":""}}],"conditions":[{"field":"3255f49ba","value":"1","operand":"and"}],"prefix":"58,82 €/Stk.","sufix":"58,82"},{"is_block":false,"label":"Fallrohrsieb Zink (Lieferung und Einbau)","id":"8b7efec3e","type":"number","options":[],"yes_no":{},"min_max":{"min":"0","max":"20"},"calculations":[{"items":[{"input":"this","operator":"*","number":""},{"input":"number","operator":"=","number":"10.08"}],"condition":{"type":"default","field":"","value":""}}],"conditions":[{"field":"3255f49ba","value":"1","operand":"and"}],"prefix":"10,08 €/Stk.","sufix":"10,08"},{"is_block":false,"label":"Fallrohrsieb Kupfer (Lieferung und Einbau)","id":"b79720abb","type":"number","options":[],"yes_no":{},"min_max":{"min":"0","max":"20"},"calculations":[{"items":[{"input":"this","operator":"*","number":""},{"input":"number","operator":"=","number":"11.76"}],"condition":{"type":"default","field":"","value":""}}],"conditions":[],"prefix":"11,76 €/Stk.","sufix":"11,76"},{"is_block":false,"label":"Garagendach abfegen","id":"7d796c862","type":"number","options":[],"yes_no":{},"min_max":{"min":"0","max":"20"},"calculations":[{"items":[{"input":"this","operator":"*","number":""},{"input":"number","operator":"=","number":"20"}],"condition":{"type":"default","field":"","value":""}}],"conditions":[{"field":"3255f49ba","value":"1","operand":"and"}],"prefix":"20,00 €/Stk.","sufix":"20,00"},{"is_block":false,"label":"Reinigung des Vordaches","id":"69ab1e577","type":"number","options":[],"yes_no":{},"min_max":{"min":"0","max":"20"},"calculations":[{"items":[{"input":"this","operator":"*","number":""},{"input":"number","operator":"=","number":"10"}],"condition":{"type":"default","field":"","value":""}}],"conditions":[{"field":"3255f49ba","value":"1","operand":"and"}],"prefix":"10,00 €/Stk.","sufix":"10,00"}],"depends_on":"d4bd891ff","value":0,"result":0,"groups":[]}],"headers":[],"show_mochten":true,"description":"Wir stehen Ihnen mit unserer 15-jährigen Erfahrung im Bereich Dachrinnenreinigung gerne zur Verfügung und machen Ihnen das Leben ein Stück weit einfacher. nnHolen Sie Ihre Nachbarn mit ins Boot und sichern Sie sich einen Rabatt auf Ihre Dachrinnenreinigung. Als Besteller sparen Sie ab dem 5. Reihenhaus 19 Euro. Ab dem 10. Reihenhaus ist die Reinigung für Sie komplett kostenlos."},{"title":"DACHRINNENREINIGUNG GROSSKUNDE","id":"4ccb86a2fc70f","image":"https://dachrinnen-reinigen.de/wp-content/plugins/dodel-dachrinnen-reinigen-rechner/uploads/1639007162.png","fields":[{"is_block":false,"label":"bis 4m","id":"8b5c37819","type":"number","options":[],"yes_no":{},"min_max":{"min":"0","max":"1000"},"calculations":[],"conditions":[],"prefix":"lfdm","value":0,"result":0},{"is_block":false,"label":"4m - 6,5m","id":"61994b237","type":"number","options":[],"yes_no":{},"min_max":{"min":"0","max":"1000"},"calculations":[],"conditions":[],"prefix":"lfdm","value":0,"result":0},{"is_block":false,"label":"6,5m - 9m","id":"721585f8","type":"number","options":[],"yes_no":{},"min_max":{"min":"0","max":"1000"},"calculations":[],"conditions":[],"prefix":"lfdm","value":0,"result":0},{"is_block":false,"label":"Laubstop reinigen/demontieren","id":"cebc7bc9c","type":"number","options":[],"yes_no":{},"min_max":{"min":"0","max":"1000"},"calculations":[],"conditions":[],"prefix":"lfdm","value":0,"result":0},{"is_block":false,"label":"Zusatzleistungen","id":"80a3621b2","type":"switch","options":[],"yes_no":{"yes":"ja","no":"nein"},"min_max":{},"calculations":[],"conditions":[],"value":0,"result":0},{"is_block":false,"label":"Dachrinnen Innenanstrich Dickschicht Lasur","id":"8a86a0f7d","type":"number","options":[],"yes_no":{},"min_max":{"min":"0","max":"1000"},"calculations":[],"conditions":[{"field":"80a3621b2","value":"1","operand":"and"}],"prefix":"lfdm","value":0,"result":0},{"is_block":false,"label":"Reparatur Dehnungsstück bis 6,5m","id":"dd0a043e2","type":"number","options":[],"yes_no":{},"min_max":{"min":"0","max":"20"},"calculations":[],"conditions":[{"field":"80a3621b2","value":"1","operand":"and"}],"prefix":"Stk.","value":0,"result":0},{"is_block":false,"label":"Fallrohrsieb Zink (Lieferung und Einbau)","id":"fc24158a","type":"number","options":[],"yes_no":{},"min_max":{"min":"0","max":"20"},"calculations":[],"conditions":[{"field":"80a3621b2","value":"1","operand":"and"}],"prefix":"Stk.","value":0,"result":0},{"is_block":false,"label":"Fallrohrsieb Kupfer (Lieferung und Einbau)","id":"e2078b157","type":"number","options":[],"yes_no":{},"min_max":{"min":"0","max":"20"},"calculations":[],"conditions":[{"field":"80a3621b2","value":"1","operand":"and"}],"prefix":"Stk.","value":0,"result":0}],"headers":[],"show_mochten":false,"show_coupon":false,"description":"Sollten Sie Großkunde sein, so bieten wir unsere Dienstleistungen zu Sonderkonditionen. Als Großkunde können Sie sich bezeichnen, wenn es sich um eine Schule, eine Behörde, eine Hausverwaltung, industrielle Firma oder Kaserne handelt. Dachrinnenreinigungen bieten wir im gesamten nördlichen Deutschland an. Handelt es sich um ein großes Projekt, so können Sie auch eine Anfrage auf bundesweite Arbeit stellen. Natürlich erhalten Sie Dachrinnenreinigungen als Großkunde zu einem fairen Preis, welcher sich als Mengenrabatt verstehen kann. So kommen Sie günstig davon, ohne dass wir bei der Arbeit Kompromisse eingehen. Überzeugen Sie sich selbst und werden Sie glücklicher Großkunde!"}]
    }
  },
  mounted(){
    this.sections = window.sections;
    if(this.sections.length==1)
      this.current_section = 0
    // this.sections.push(this.sections[this.sections.length-1])
    // this.sections = this.sections.map(item=>{
    //   item.minimum_amount_active = true
    //   item.minimum_amount = '60'

    //   item.travel_cost_active = true
    //   item.travel_cost_minimum = '129'
    //   item.travel_cost_amount = '30'

    //   item.discount_active = true
    //   item.discounts = [
    //     {
    //       minimum_amount: 300,
    //       percent: 10
    //     },
    //     {
    //       minimum_amount: 3000,
    //       percent: 15
    //     }
    //   ]
    //   return item
    // })

    axios.get('/wp-admin/admin-ajax.php?action=dodel-load-tech-data').then(response=>{
      this.footer_text_quote = response.data['pdf-text-quote']
      this.footer_text_order = response.data['pdf-text-order']

      this.header = response.data['pdf-header']
      this.footer = response.data['pdf-footer']
      this.heading = response.data['pdf-heading']
      this.thankyoupage = response.data['thank-you-page-url']
      this.agburl = response.data['agb-url']

      this.triggerEvent("form_opened");
      this.triggerEventBing("Contact form opened");
    })

    this.sections.map(section=>{
      section.fields.map(field=>{
        field.value=0; // should take minimal option
        field.result=0;
        if(field.is_block)
          field.groups = []
        if(field.type=='text')
          field.value = 1;
        return field
      })
      return section
    })
  }
}
</script>

<style scoped>
  .dodel-calculator{
    width: 812px;
    margin: 20px auto;
    max-width: 100%;
    margin-top: 100px;
  }
  .sections-block{
    display: flex;
    margin-left: -8px;
    margin-right: -8px;
    justify-content: center;
  }
  .sections-block .section{
    width: 200px;
    height: 240px;
    cursor: pointer;
    margin: 0 8px;
  }
  .sections-block .section .image{
    width: 200px;
    height: 200px;
    overflow: hidden;
    border: 3px solid #204097;
    border-radius: 20px;
    opacity: 1;
    position: relative;
    box-sizing: border-box;
    transition: all .5s;
  }
  .sections-block .section.active .image{
    border: 10px solid #204097;
    box-shadow: 0px 13px 26px #00000075;
  }
  .sections-block .section .title{
    text-align: center;
    font: normal normal bold 20px/25px Helvetica Neue;
    letter-spacing: 0px;
    color: #204097;
    opacity: 1;
    margin-top: 10px;
  }
  .sections-block .section .image .overflow{
    background: #20409740 0% 0% no-repeat padding-box;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    z-index: 2;
    bottom: 0;
  }
  .sections-block .section .image img{
    object-fit: cover;
    width: 260px;
    position: relative;
    z-index: 1;
    height: 260px;
  }
  .section-content{
    margin-top: 47px;
    font-family: sans-serif;
  }
  .section-content h1{
    text-align: left;
    letter-spacing: 0px;
    font: normal normal bold 32px/39px Helvetica Neue;
    color: #1870B1;
    opacity: 1;
  }
  .section-content .section-description{
    text-align: left;
    font: normal normal normal 20px/24px Helvetica Neue;
    letter-spacing: 0px;
    color: #000000;
    opacity: 1;
    margin-top: 33px;
  }
  .section-content .fields-block{
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 13px 26px #00000029;
    box-shadow: none;
    border-radius: 10px;
    border-radius: 0;
    opacity: 1;
    margin-top: 49px;
    padding: 35px;
  }

  .section-content .fields-block .fields-block-header{
    background: #20409740 0% 0% no-repeat padding-box;
    background: #ffffff;
    border-radius: 10px 10px 0px 0px;
    opacity: 1;
    margin: -35px;
    padding: 25px 35px;
    margin-bottom: 35px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid rgba(0,0,0,.1);
  }
  .section-content .fields-block .fields-block-header div{
    text-align: left;
    font: normal normal bold 20px/25px Helvetica Neue;
    letter-spacing: 0px;
    color: #204097;
    color: #25262F;
    opacity: 1;
  }
  .field-block-field{
    display: grid;
    grid-template-columns: 2fr 3fr 1fr;
    grid-column-gap: 10px;
    padding: 10px 0;
    padding: 0;
    margin-bottom: 10px;
    font: normal normal normal 20px/24px Helvetica Neue;
    letter-spacing: 0px;
    color: #000000;
  }
  .field-block-field .label{
    flex-basis: 30%;
    padding: 10px;
    background-color: #F7F9FF;
    color: #818292;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .field-block-field .field{
    text-align: left;
    /* background: red; */
    display: grid;
    grid-template-columns: 1fr 1fr;
    align-items: center;
    padding: 10px;
    background-color: #F7F9FF;
    color: #818292;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .field-block-field .calculation{
    font: normal normal bold 20px/25px Helvetica Neue;
    text-align: right;
    padding: 10px;
    background-color: #F7F9FF;
    color: #818292;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .fields-block-totals{
    display: flex;
    /* grid-template-columns: 1fr 1fr 1fr; */
    justify-content: space-between;
    align-items: center;
    border-top: 1px solid rgba(0,0,0,.1);
    margin: -35px;
    padding: 30px 35px;
    margin-top: 30px;
    
  }
  .fields-block-totals .logo{
    padding: 20px 0;
  }
  .fields-block-totals .logo img{
    width: 190px;
    height: auto;
  }
  .fields-block-totals .summe-title, .fields-block-totals .numbers{
    text-align: left;
    font: normal normal bold 18px/42px Helvetica Neue;
    letter-spacing: 0px;
    color: #000000;
    opacity: 1;
  }
  .fields-block-totals .numbers{
    text-align: right;
  }
  .fields-block-totals .mindestumsatz{
    color: #204097;
  }
  button:disabled{
    cursor: default;
    opacity: .7;
  }
  .button-secondary{
    height: 49px;
    background: #B9B9B9 0% 0% no-repeat padding-box;
    border-radius: 25px;
    border-radius: 0;
    opacity: 1;
    border: 0;
    padding: 0 30px;
    text-align: center;
    font: normal normal bold 16px/19px Helvetica Neue;
    letter-spacing: 0px;
    color: #FFFFFF;
    text-transform: uppercase;
    opacity: 1;
    cursor: pointer;
  }
  .button-primary{
    height: 49px;
    background: #204097 0% 0% no-repeat padding-box;
    border-radius: 25px;
    border-radius: 0;
    opacity: 1;
    border: 0;
    padding: 0 30px;
    text-align: center;
    font: normal normal bold 16px/19px Helvetica Neue;
    letter-spacing: 0px;
    color: #FFFFFF;
    text-transform: uppercase;
    opacity: 1;
    cursor: pointer;
  }
  .buttons-block{
    display: flex;
    justify-content: space-between;
    padding-top: 30px;
    align-items: center;
  }
  .mochten .mochten-switch{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .mochten .text-de{
    flex-basis: 61%;
    text-align: left;
    font: normal normal normal 18px/24px Helvetica Neue;
    letter-spacing: 0px;
    color: #000000;
    opacity: 1;
  }
  .contact-fields-block{
    padding-top: 30px;
  }
  .mochten .months-title{
    text-align: left;
    font: normal normal normal 18px/24px Helvetica Neue;
    letter-spacing: 0px;
    color: #000000;
    opacity: 1;
  }
  .mochten .months{
    display: flex;
    justify-content: space-between;
  }
  .mochten .months select{
    flex-basis: 48%;
  }
  .mochten .mochten_on{
    margin-top: 17px;
  }
  .mochten .months-title{
    margin-top: 17px;
    margin-bottom: 17px;
  }
  .contact-fields-block .fields-group{
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
  }
  .contact-fields-block .fields-group div{
    flex-basis: 46%;
  }
  .contact-fields-block .fields-group div label{
    display: block;
    text-align: left;
    font: normal normal normal 20px/24px Helvetica Neue;
    letter-spacing: 0px;
    color: #000000;
    opacity: 1;
    margin-bottom: 10px;
  }
  .contact-fields-block .fields-group div input{
    width: 100%;
  }
  .contact-fields-block .contact-fields{
    background: #2040971A 0% 0% no-repeat padding-box;
    border-radius: 0px 0px 10px 10px;
    opacity: 1;
    margin: -35px;
    margin-top: 35px;
    padding: 35px;
  }
  .has_different_billing_address{
    display: flex;
    margin-bottom: 17px;
    align-items: center;
    text-align: left;
    font: normal normal normal 18px/24px Helvetica Neue;
    letter-spacing: 0px;
    color: #000000;
    opacity: 1;
  }
  .has_different_billing_address .text-desc{
    margin-left: 10px;
  }
  .one_of_multiple_contacts h4{
      font-weight: bold;
      font-size: 22px;
      display: flex;
      align-items: center;
      white-space: nowrap;
      color: rgba(0,0,0,.3);
  }
  .one_of_multiple_contacts h4:after{
      content: '';
      height:1px;
      margin-left: 10px;
      background: rgba(0,0,0,.3);
      display: block;
      flex-basis: 100%;
  }
  .contacts_footer_block{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
  }
  .main-pdf-content{
    padding: 0 15mm;
    /* overflow: hidden; */
    /* padding-top: calc(15mm + 210px); */
    /* background-image: url('/pdf_bg.png'); */
    background-size: 100%;
    /* background-repeat: repeat-y; */
    /* height: 297mm; */
    box-sizing: border-box;
    width: 210mm;
    font-family: sans-serif;
  }
  /* .main-pdf-content .pdf-inner{
    background: red;
  } */
  .main-pdf-content .main-address{
    font-size: 14px;
    font-weight: bold;
    width: 100%;
    padding: 0 6mm;
    box-sizing: border-box;
    color: #000;
    padding-top: 15mm;
    padding-left: 0;
    font-weight: normal;
    line-height: 14px;
  }
  .main-pdf-content .date-of-pdf{
    margin-top: 75px;
    font-size: 12px;
    font-weight: bold;
    color: #000;
  }
  .main-pdf-content .title-of-pdf{
    font-weight: bold;
    font-size: 24px;
    color: #000;
  }
  .main-pdf-content .grid-pdf{
    margin-top: 30px;
    width: 100%;
  }
  .main-pdf-content .grid-pdf table{
    width: 100%;
  }
  .main-pdf-content .ihre-address{
    font-size: 12px;
    margin-top: 20px;
  }
  .main-pdf-content .grid-pdf thead, .main-pdf-content .grid-pdf thead th{
    background: #204097;
    color: #fff;
    font-size: 14px !important;
    
  }
  .main-pdf-content .grid-pdf thead th{
    text-align: center;
    width: 25%;
    padding: 3px !important;
    line-height: 14px !important;
  }
   .main-pdf-content .grid-pdf td{
     width: 25%;
     padding: 3px !important;
     color: #000;
     font-size: 12px  !important;
     line-height: 14px !important;
     font-weight: normal  !important;
     text-align: left  !important;
   }
  .main-pdf-content .grid-pdf .text-center-col{
    text-align: center !important;
  }
  .main-pdf-content .grid-pdf tfoot td.text-center-col{
    width: 25%;
  }
  .main-pdf-content .grid-pdf tfoot td.text-right-col{
    width: 75%;
  }
  .main-pdf-content .grid-pdf .text-right-col{
    text-align: right !important;
  }
  .main-pdf-content tfoot tr td{
    font-weight: bold;
    text-align: right  !important;
  }
  .main-pdf-content tfoot tr:first-child td{
    border-top: 2px solid black ;
  }
  .main-pdf-content tfoot tr:last-child td{
    border-top: 2px solid black;
    border-bottom: 2px solid black;
    font-size: 18px  !important;
    line-height: 18px  !important;
  }
  .main-pdf-content .pdf-mochten{
    margin-top: 20px;
    font-size: 12px !important;
    line-height: 14px  !important;
    font-weight: normal  !important;
  }
  .main-pdf-content .footer-of-pdf{
    margin-top: 20px;
    font-size: 12px !important;
    font-weight: normal !important;
    text-align: left !important;
    color: #000;
  }

  .fields-group .error label, .fields-group .error{
    color: #97202a !important;
  }
  .fields-group .error input{
    border-color: #97202a !important;
  }
  @media screen and (max-width: 768px){
    .sections-block .section{
      width: 20vw;
      height: 25vw;
    }
    .sections-block .section .image{
      width: 20vw;
      height: 20vw;
    }
    .sections-block .section .image img{
      width: 20vw;
      height: 20vw;
    }
  }
  @media screen and (max-width: 768px){
    .section-content .fields-block{
      padding: 15px;
    }
    .sections-block{
      margin-left: 0;
      margin-right: 0;
    }
    .field-block-field{
      display: flex;
      flex-wrap: wrap;
      grid-template-columns: none !important;
      grid-gap: 0 !important;
    }
    .field-block-field .label, .field-block-field .field{
      flex-basis: 50%;
      box-sizing: border-box;
      display: block; 
      clear: both;
      float: none;
    }
    .field-block-field .field div{
      float: right;
    }
    .field-block-field .label{
      white-space: pre-line;
      word-break: break-all;
    }
    .section-content .fields-block .fields-block-header{
      margin: -15px;
      padding: 15px 15px;
      margin-bottom: 15px;
    }
    .section-content h1{
      font: normal normal bold 26px/39px Helvetica Neue;
    }
    .field-block-field .calculation{
      flex-basis: 100%;
      margin-top: 10px;
    }
    .sections-block .section{
      width: 23vw;
      height: 26vw;
      margin: 0 2px;
    }
    .sections-block .section .image{
      width: 23vw;
      height: 23vw;
    }
    .sections-block .section .image img{
      width: 23vw;
      height: 23vw;
    }
    .sections-block .section .title{
      font-size: 2vw;
      word-break: break-all;
      /* text-overflow: ellipsis; */
      /* overflow: hidden; */
      line-height: 2vw;
    }
    .sections-block .section.active .image{
      border-width: 5px;
    }
    .fields-block-totals .logo,  .field-block-field .suffix{
      display: none !important;
    }
    .field-block-field .prefix{
      font-size: 16px;
      display: block;
      float: none !important;
      text-align: right;
    }
    .fields-group{
      display: block !important;
      margin-bottom: 0px !important;
    }
    .fields-group div{
      flex-basis: 100% !important;
      margin-bottom: 20px !important;
    }
    .contacts_footer_block{
      display: block !important;
    }
    .contacts_footer_block .ddlc-checkbox{
      margin-bottom: 20px !important;
    }
    .tab-input div{
      white-space: nowrap;
    }
    .field-block-field{
      grid-template-columns: 1fr 1fr 1fr !important;
      white-space: nowrap;
      align-items: center;
      grid-gap: 10px;
    }
    .field-block-field .field{
      display: block !important;
    }
    .buttons-block{
      display: block ;
      text-align: center;
    }
    .buttons-block button{
      margin-bottom: 10px;
    }
    .contact-fields-block input[type="text"], .contact-fields-block textarea{
      width: 100%;
      margin-top: 10px;
    }
    .contact-fields-block label{
      font: normal normal normal 20px/24px Helvetica Neue;
    }
    .contact-fields-block .code_and_comment div{
      margin-bottom: 20px;
    }
    
    .main-pdf-content{
    padding: 0 15mm;
    /* overflow: hidden; */
    /* padding-top: calc(15mm + 210px); */
    /* background-image: url('/pdf_bg.png'); */
    background-size: 100%;
    /* background-repeat: repeat-y; */
    /* height: 297mm; */
    box-sizing: border-box;
    width: 210mm;
    font-family: sans-serif;
  }
  /* .main-pdf-content .pdf-inner{
    background: red;
  } */
  .main-pdf-content .main-address{
    font-size: 14px;
    font-weight: bold;
    width: 100%;
    padding: 0 6mm;
    box-sizing: border-box;
    color: #000;
    padding-top: 15mm;
  }
  .main-pdf-content .date-of-pdf{
    margin-top: 75px;
    font-size: 12px;
    font-weight: bold;
    color: #000;
  }
  .main-pdf-content .title-of-pdf{
    font-weight: bold;
    font-size: 24px;
    color: #000;
  }
  .main-pdf-content .grid-pdf{
    margin-top: 30px;
    width: 100%;
  }
  .main-pdf-content .grid-pdf table{
    width: 100%;
  }
  .main-pdf-content .ihre-address{
    font-size: 12px;
    margin-top: 20px;
  }
  .main-pdf-content .grid-pdf thead, .main-pdf-content .grid-pdf thead th{
    background: #204097;
    color: #fff;
    font-size: 14px !important;
    
  }
  .main-pdf-content .grid-pdf thead th{
    text-align: center;
    width: 25%;
  }
   .main-pdf-content .grid-pdf td{
     width: 25%;
     color: #000;
     font-size: 12px  !important;
     font-weight: normal  !important;
     text-align: left  !important;
   }
  .main-pdf-content .grid-pdf .text-center-col{
    text-align: center !important;
  }
  .main-pdf-content .grid-pdf tfoot td.text-center-col{
    width: 25%;
  }
  .main-pdf-content .grid-pdf tfoot td.text-right-col{
    width: 75%;
  }
  .main-pdf-content .grid-pdf .text-right-col{
    text-align: right !important;
  }
  .main-pdf-content tfoot tr td{
    font-weight: bold;
    text-align: right  !important;
  }
  .main-pdf-content tfoot tr:first-child td{
    border-top: 2px solid black ;
  }
  .main-pdf-content tfoot tr:last-child td{
    border-top: 2px solid black;
    border-bottom: 2px solid black;
    font-size: 18px  !important;
    line-height: 18px  !important;
  }
  .main-pdf-content .pdf-mochten{
    margin-top: 20px;
    font-size: 12px !important;
    line-height: 14px  !important;
    font-weight: normal  !important;
  }
  .main-pdf-content .footer-of-pdf{
    margin-top: 20px;
    font-size: 12px !important;
    font-weight: normal !important;
    text-align: left !important;
    color: #000;
  }
  }
</style>
